export default {"src":"/_next/static/media/dollar.9ef6b67d.svg","height":84,"width":84,"blurWidth":0,"blurHeight":0};